// Component
const ModalMultipleBrands = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "modal-multiple-brands" */ "@/app/views/main-view/products/containers/product-cart-container/modals/modal-multiple-brands/modal-multiple-brands.vue"
	)
const ProductItemCard = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "product-item-card" */ "@/app/views/main-view/_shared/_components/product-item-card/product-item-card.vue"
	)
const CartCard = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "cart-card" */ "@/app/views/main-view/products/components/cart-card/cart-card.vue"
	)

// Services
import SubscriptionService from "@/app/services/main/subscription/subscription-service.js"
import CartService from "@/app/services/main/cart/cart-service.js"

// Constants
import { STATUS_CODES, SUCCESS_MSG } from "@/app/constants/status-constants"
import { FREQUENCY_API_CODE, PERIOD_CODE } from "@/app/constants/subscription-constants"

// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins.js"
import { userMixins } from "@/app/mixins/modules/user-mixins.js"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { shoppingMixins } from "@/app/mixins/components/shopping-mixins"

// Event Bus
import EventBus from "@/app/bus/event-bus.js"

export default {
	name: "CartTable",
	components: { ModalMultipleBrands, ProductItemCard, CartCard },
	mixins: [tableMixins, userMixins, toastMessageMixins, shoppingMixins],
	data() {
		return {
			// table data
			subscriptionData: [],
			// loaders
			isAPILoading: false,
			// table
			theads: [
				{ name: "Product Image", sortLabel: null, isDesc: false, style: null },
				{ name: "Product Name", sortLabel: null, isDesc: false, style: null },
				// { name: 'Brand', sortLabel: null, isDesc: false, style: null},
				{ name: "Quantity", sortLabel: null, isDesc: false, style: null },
				{ name: "Price", sortLabel: null, isDesc: false, style: null },
				{ name: null, sortLabel: null, isDesc: false, style: "width: 80px" },
			],
			// sorting
			desc: true,
			totalPrice: 0,
			// modal
			modalContent: {
				bundleName: "",
				brands: [],
			},
			cancelCheckoutValidation: true,
			fromCheckout: this.$route.query.fromCheckout,
			cancelLowOnStockValidation: true,
			editQty: false,

			// dropdown
			frequencyList: [],
			periodList: [],
			ageList: {
				A: "Adult",
				P: "Puppy",
			},

			// validations
			productPriceChangeList: [],
			productInactiveList: [],
			productOutOfStockList: [],
			productLowOnStockList: [],
			bundleIdsToDelete: [],

			// delivery
			deliveryMin: process.env.VUE_APP_DELIVERY_MIN,
			deliveryFee: process.env.VUE_APP_DELIVERY_FEE,
		}
	},
	props: {
		origin: {
			type: String,
			required: true,
		},
	},
	computed: {
		selectedTable: {
			get() {
				return this.$store.getters.getSelectedCartTable
			},
			set(value) {
				this.$store.commit("setSelectedCartTable", value)
			},
		},
		cartItems() {
			return this.$store.getters.getSelectedCartContent
		},
		isItemDeactivated() {
			return this.$store.getters.getIsProductDeactivated
		},
		isItemOutOfStock() {
			return this.$store.getters.getIsProductOutOfStock
		},
		isCartCheckoutEnabled() {
			return this.$store.getters.getIsCheckoutEnabled
		},
	},
	created() {
		if (this.origin === "checkout") {
			this.theads.pop()
		} else {
			this.selectedTable = ""
		}

		this.getCartList()
		this.getSubscriptionPeriod()
	},
	watch: {
		selectedTable(newVal) {
			if (newVal) {
				this.modifySelectedCartContent()
				this.computeTotal()
				this.isCheckoutEnabled()
			}
		},
	},
	methods: {
		getSubscriptionPeriod() {
			this.isAPILoading = true
			SubscriptionService.getSubscriptionPeriod().then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					// Added key Monthly, Quarterly and Yearly
					this.frequencyList = res.data.paymentFrequency
					this.periodList = res.data.subscriptionPeriod
				}
				this.isAPILoading = false
			})
		},
		getCartList() {
			this.isAPILoading = true

			const cartDetails = {
				f_type: "products",
			}

			CartService.getCart(this.getActivePet.id, cartDetails).then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					this.separateSubAndNonSub(res.data)
				} else {
					this.showAPIErrorToast("", res)
				}
				this.isAPILoading = false
			})
		},
		async separateSubAndNonSub(cartData) {
			let subscriptions = []
			let nonSubscription = []

			await cartData.forEach((item) => {
				if (!item.subscriptionBundle) {
					nonSubscription.push(item)
				}
			})

			this.$store.commit("resetIsProductDeactivated")
			this.tableContent.tableData = nonSubscription
			this.selectedTable = "nonSub"

			this.$store.commit("setCartCount", nonSubscription.length)
			await this.modifySelectedTable(subscriptions, nonSubscription)
			this.productLowOnStockList = this.checkBundleLowOnStock(nonSubscription)

			if (nonSubscription.length && this.cancelCheckoutValidation) {
				await this.checkoutValidationsModal(nonSubscription)
			}

			this.computeTotal()
		},
		async modifySelectedTable(sub, nonSub) {
			if (this.selectedTable) {
				const selectedNonSubCartHasNoItem = this.selectedTable === "nonSub" && nonSub.length === 0
				const selectedSubscriptionDoesntExist =
					this.selectedTable !== "nonSub" &&
					sub.find((item) => item.bundleId === this.selectedTable) === undefined

				if (selectedNonSubCartHasNoItem || selectedSubscriptionDoesntExist) {
					this.$store.commit("clearSelectedCartTableAndContent")
					this.$store.commit("clearTotalPrice")
					this.$store.commit("resetIsProductDeactivated")
					this.$store.commit("resetIsProductChanged")
					// Redirect user back to Cart page if they deleted all items.
					if (this.$route.path === "/products/checkout") {
						this.$router.replace("/cart")
					}
				}
			}
		},
		modifySelectedCartContent() {
			if (this.selectedTable) {
				if (this.selectedTable === "nonSub") {
					const nonSubItems = JSON.parse(JSON.stringify(this.tableContent.tableData))
					this.$store.commit("setSelectedCartContent", nonSubItems)
				} else {
					// Pass the SelectedTable which is the subscription ID as cart content.
					const subscriptionItem = JSON.parse(
						JSON.stringify(this.subscriptionData.find((item) => item.bundleId === this.selectedTable))
					)
					this.$store.commit("setSelectedCartContent", [subscriptionItem])
				}
			}
		},

		computeTotal() {
			this.totalPrice = 0
			if (this.selectedTable === "nonSub") {
				const tableData = this.tableContent.tableData

				for (const key in tableData) {
					if (tableData.hasOwnProperty(key)) {
						const cart = tableData[key]
						if (!this.checkProductDeactivated(cart) && !this.checkProductOutOfStock(cart)) {
							let productPrice = cart.onSale
								? parseFloat(cart.salePrice)
								: parseFloat(cart.currentBundlePrice)

							this.totalPrice += productPrice * cart.quantity
						}
					}
				}
			} else {
				const subscriptionItem = this.subscriptionData.find((item) => item.bundleId === this.selectedTable)

				if (subscriptionItem) {
					if (!this.checkProductDeactivated(subscriptionItem)) {
						this.totalPrice = parseFloat(subscriptionItem.price)
					}
				}
			}

			this.isCheckoutEnabled()

			let newTotalPrice = this.totalPrice;

			if(this.totalPrice <= parseFloat(this.deliveryMin) && this.totalPrice > 0){
				newTotalPrice = this.totalPrice + parseFloat(this.deliveryFee); // include delivery fee
			}
			
			this.$store.commit("setSubtotalPrice", this.totalPrice);
			this.$store.commit("setTotalPrice", newTotalPrice);
		},
		numberOnlyInput(event) {
			const charCode = event.which ? event.which : event.keyCode

			if (charCode > 31 && (charCode < 48 || charCode > 57)) {
				event.preventDefault()
			} else {
				return true
			}
		},

		setCartQtyFrequencyPeriod(event, cart, src) {
			switch (src) {
				case "qty":

					if (event.target.value.trim() === "") {
						event.target.value = cart.quantity
					} else if (event.target.value !== cart.quantity) {
						cart.quantity = event.target.value
					}
					break

				case "fqy":
					cart.cartPaymentFrequency = event
					if (event === FREQUENCY_API_CODE.P12M && cart.cartSubscriptionPeriod === PERIOD_CODE.P6M) {
						cart.cartSubscriptionPeriod = PERIOD_CODE.P1Y
					}
					break

				case "period":
					cart.cartSubscriptionPeriod = event
					break

				case "btn":
					if (event <= 0) {
						return
					}

					// if (event > cart.products[0].productInventory.stockQty) {
					// 	event = cart.products[0].productInventory.stockQty
					// }

					cart.quantity = event
					break
			}

			this.editQty = true
			if (!cart.isPriceChange) {
				this.updateCartProduct([cart])
			}
		},

		setBundleQty(product) {
			if (product.quantity < 1 || product.quantity >= 999) {
				return 1;
			}

			return product.quantity;
			// if (product.products[0].productInventory.stockQty <= 0) return 1

			// return product.quantity > product.products[0].productInventory.stockQty
			// 	? product.products[0].productInventory.stockQty
			// 	: product.quantity
		},

		alterPeriodList(fqy) {
			let periodListTmp = [...this.periodList]

			// remove 6 months on period for yearly frequency
			if (fqy === FREQUENCY_API_CODE.P12M) {
				periodListTmp.shift()
			}

			return periodListTmp
		},

		async updateCartProduct(cart) {
			if (!cart.length) return

			this.cancelCheckoutValidation = false
			this.cancelLowOnStockValidation = false
			// - NOTE: Add loop for every products in cart to set cartDetails
			let productDetails
			let productsToUpdate = []

			cart.forEach((product) => {
				// product.quantity > product.products[0].productInventory.stockQty
				// 		? product.products[0].productInventory.stockQty
				// 		: product.quantity,
				productDetails = {
					quantity: product.quantity,
					bundleId: product.bundleId,
				}

				if (product.subscriptionBundle) {
					productDetails = {
						...productDetails,
						subscriptionPeriodCode: product.cartSubscriptionPeriod,
						paymentFrequencyCode: product.cartPaymentFrequency,
					}
				}

				productsToUpdate.push(productDetails)
			})

			const res = await CartService.putCart(this.getActivePet.id, productsToUpdate)
			try {
				if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
					// show toast message
					if (!this.editQty) {
						const { SUCCESS_UPDATE_CART } = this.toastMessages.cart()
						this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_UPDATE_CART)
					}

					// refresh the table
					this.getCartList()
					EventBus.$emit("updateStoreCreditPreview")
					this.isCheckoutEnabled()
					this.editQty = false
				} else {
					const { ERROR_UPDATE_CART } = this.toastMessages.cart()
					if (res.data.errors.length == 2) {
						this.showCustomErrorToast(ERROR_UPDATE_CART, "Set Payment Frequency and Subscription Period")
					} else {
						const err =
							res.data.errors[0].message === "Subscription Period Code must be a string."
								? "Set Subscription Period"
								: "Set Payment Frequency"
						this.showCustomErrorToast(ERROR_UPDATE_CART, err)
					}
				}
			} catch (err) {
				this.showGenericErrorToast()
			}
		},

		checkIfMultipleBrands(bundleProducts) {
			// Remove Null and Duplicate Brands in a single Product List.
			const brands = [...new Set(bundleProducts.map((item) => item.brand.name))]

			return {
				name: brands.length > 1 ? "MULTIPLE BRANDS" : brands[0],
				brands,
				isMultiple: brands.length > 1,
			}
		},
		showMultipleBrands({ isMultiple, brands }, bundleName) {
			if (isMultiple) {
				this.modalContent = {
					bundleName,
					brands,
				}
				setTimeout(() => {
					this.$refs.modalMultipleBrands.show()
				}, 100)
			}
		},
		hasProductImage(cart) {
			let imgUrl = require("@/assets/images/product/product-default.png")
			if (!cart.isCustomBundle) {
				for (const key in cart.products) {
					const product = cart.products[key]
					if (product.productImg) {
						imgUrl = product.productImg
						break
					}
				}
			} else {
				if (cart.bundleImg) {
					imgUrl = cart.bundleImg
				}
			}
			return imgUrl
		},
		deleteCart(cart) {
			this.$swal({
				imageHeight: "30px",
				imageUrl: `${require("@/assets/images/_shared/dog-confirm.png")}`,
				imageAlt: "Dog Confirm",
				title: "Remove to Cart",
				text: `Are you sure you want to remove ${cart.name}?`,
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
			}).then((result) => {
				if (result.value) {
					this.bundleIdsToDelete = [cart.bundleId]
					this.callDeleteCartAPI([cart.bundleId])
				}
			})
		},

		async callDeleteCartAPI(bundleIds) {
			this.cancelCheckoutValidation = false
			this.cancelLowOnStockValidation = false

			if (!this.bundleIdsToDelete.length) return

			try {
				const res = await CartService.deleteCart(this.getActivePet.id, bundleIds)
				if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
					// show toast message
					const { SUCCESS_DELETE_CART } = this.toastMessages.cart()
					this.showCustomSuccessToast(
						SUCCESS_MSG.SUCCESS_TITLE,
						`${
							this.bundleIdsToDelete.length > 1
								? this.bundleIdsToDelete.length + " items has been removed from the cart"
								: SUCCESS_DELETE_CART
						}`
					)

					this.bundleIdsToDelete = []
					// refresh the table
					this.getCartList()
					EventBus.$emit("updateStoreCreditPreview")

					// refresh cart count
					this.setCartCount(this.getActivePet.id)
				} else {
					const { ERROR_DELETE_CART } = this.toastMessages.cart(cart.name)
					this.showAPIErrorToast(ERROR_DELETE_CART, res)
				}
			} catch (error) {
				this.showGenericErrorToast()
			}
		},

		priceChangeTextContent(cart) {
			if (!cart.onSale) {
				return `Are you sure you want to confirm $${cart.price} to $${cart.currentBundlePrice}?`
			}
			return `Are you sure you want to confirm $${cart.currentBundlePrice} to the sale price of $${cart.salePrice}?`
		},

		confirmPriceChange(cart) {
			let priceChangeTextContent = this.priceChangeTextContent(cart)

			this.$swal({
				imageHeight: "30px",
				imageUrl: `${require("@/assets/images/_shared/dog-confirm.png")}`,
				imageAlt: "Confirm Dog",
				title: "Price Changed",
				text: priceChangeTextContent,
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
			}).then((result) => {
				if (result.value) {
					this.updateCartProduct([cart])
				}
			})
		},

		productOutOfStockModal(cart) {
			this.$swal({
				imageHeight: "30px",
				imageUrl: `${require("@/assets/images/_shared/sad-dog.png")}`,
				imageAlt: "Sad Dog",
				title: "Out of Stock",
				text: `${cart.name} is currently out of stock, remove this item from cart?`,
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
			}).then((result) => {
				if (result.value) {
					this.bundleIdsToDelete = [cart.bundleId]
					this.callDeleteCartAPI([cart.bundleId])
				}
			})
		},

		isCheckoutEnabled() {
			let tableData = []
			if (this.selectedTable) {
				if (this.selectedTable !== "nonSub") {
					tableData.push(this.subscriptionData.find((item) => item.bundleId === this.selectedTable))
				} else {
					tableData = this.tableContent.tableData
				}
			}

			let isEnabled = false
			let isChanged = false
			let isProductOutOfStock = false
			let isDeactivated = false

			if (tableData.length > 0) {
				for (const key in tableData) {
					if (tableData.hasOwnProperty(key)) {
						const cart = tableData[key]
						isChanged = cart.isPriceChange
						isDeactivated = this.checkProductDeactivated(cart)
						isProductOutOfStock = this.checkProductOutOfStock(cart)
						// Check if price change or product has been deactivated
						if (isChanged || isDeactivated || isProductOutOfStock) {
							isEnabled = true
							break
						}
					}
				}
			}

			this.$store.commit("setProductChanged", isChanged)
			this.$store.commit("setProductDeactivated", isDeactivated)
			this.$store.commit("setProductOutOfStock", isProductOutOfStock)
			this.$store.commit("setCheckoutDisabled", isEnabled)
		},

		async checkoutValidationsModal(cart) {
			if (!cart.isCustomBundle && ((!this.isCartCheckoutEnabled && this.cancelCheckoutValidation) || this.fromCheckout)) return

			// Cart validations
			this.productPriceChangeList = cart.filter((item) => item.isPriceChange === true)
			this.productInactiveList = cart.filter((item) => item.bundleStatus === "I" || item.bundleStatus === "D")


			const productOutOfStockListTmp =  cart.filter((item) => item.isCustomBundle === false)
			
			// Get bundles with out of stock products
			this.productOutOfStockList = this.checkBundleOutOfStock(productOutOfStockListTmp)

			// Return if there is no products needs to be updated
			if (
				!this.productPriceChangeList.length &&
				!this.productInactiveList.length &&
				!this.productOutOfStockList.length
			)
				return

			const priceChangeHtmlFormat = this.productPriceChangeList
				.map((item) => `<li><strong>${item.name}</strong> has a price change</li>`)
				.join("")
			const inactiveListHtmlFormat = this.productInactiveList
				.map((item) => `<li><strong>${item.name}</strong> is unavailable</li>`)
				.join("")
			const outOfStockListHtmlFormat = this.productOutOfStockList
				.map((item) => `<li><strong>${item.name}</strong> is out of stock</li>`)
				.join("")

			// Modal Sections
			const priceChangeModalSection = `
				<div style="margin-bottom: 0.3rem">
					${priceChangeHtmlFormat}
				</div>
            `
			const inactiveModalSection = `
				<div style="margin-bottom: 0.3rem">
					${inactiveListHtmlFormat}
				</div>
            `
			const outOfStockModalSection = `
				<div style="margin-bottom: 0.3rem">
					${outOfStockListHtmlFormat}
				</div>
            `
			//
			const modalContent = `
                <div style="text-align: left">
                    <p style="margin-bottom: 0.3rem; text-align: center">Please check the following updated item(s):</p>
                    ${this.productPriceChangeList.length ? priceChangeModalSection : ""}
                    ${this.productInactiveList.length ? inactiveModalSection : ""}
                    ${this.productOutOfStockList.length ? outOfStockModalSection : ""}
                </div>
            `

			this.$swal({
				imageHeight: "30px",
				imageUrl: `${require("@/assets/images/_shared/dog-confirm.png")}`,
				imageAlt: "Dog Confirm",
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				title: "Cart Updates",
				html: modalContent,
				reverseButtons: true,
			}).then((result) => {
				if (result.value) {
					const productsToDelete = [...this.productInactiveList, ...this.productOutOfStockList]
					const productsToUpdate = [...this.productPriceChangeList]
					this.bundleIdsToDelete = productsToDelete.map((product) => product.bundleId)
					this.callDeleteCartAPI(this.bundleIdsToDelete)
					this.updateCartProduct(productsToUpdate)
				}
			})
		},

		checkProductChanged(cart) {
			return cart.isPriceChange
		},

		changeColumnName(currentColumn) {
			return currentColumn === "Quantity" ? "Billing" : currentColumn
		},

		checkoutSelectedTable(checkoutItem) {
			const currentRoute = this.$route.path
			let showFlag = false

			if (currentRoute === "/products/checkout") {
				if (this.selectedTable === checkoutItem) {
					showFlag = true
				}
			} else {
				showFlag = true
			}

			return showFlag
		},

		stocksAvailable(stockQty) {
			return stockQty <= 0 || stockQty === null ? "Out of Stock" : `Available Qty: ${stockQty}`
		},
	},
}
